import { graphql } from "gql";

const MESSAGES_QUERY = graphql(`
  query Messages($id: [ID!]!) {
    messages(id: $id) {
      ...Message
    }
  }
`);

export default MESSAGES_QUERY;
